import { render, staticRenderFns } from "./LightSpeedVideoGroupEditor.vue?vue&type=template&id=9b5f41ee&"
import script from "./LightSpeedVideoGroupEditor.vue?vue&type=script&lang=ts&"
export * from "./LightSpeedVideoGroupEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports